/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { SEARCH_WINDOW_SIZE, searchDirections, pageSearchStates } from "./SearchConstants";

class SearchWindowManager {
  constructor(totalPagesInDocument, pageWhereSearchWillStart) {
    this.pagesSearchState = [];
    for (let i = 0; i < totalPagesInDocument; i++) {
      this.pagesSearchState.push(pageSearchStates.NOT_SEARCHED);
    }
    this.nextStartPage = pageWhereSearchWillStart;
  }

  getNewSearchWindow(searchDirection) {
    return this.getNextSearchWindow();
  }

  hasPageBeenSearched(pageIndex) {
    let result = false;
    if (this.pagesSearchState[pageIndex] !== pageSearchStates.NOT_SEARCHED) {
      result = true;
    }
    return result;
  }

  getPagesNotSearchedFromWindow(startPage, searchWindowSize) {
    let newStartPage = -1;
    let newSearchWindowSize = 0;
    let endPage = startPage + searchWindowSize - 1;
    let pagesNotSearched = [];
    let pageIndex = startPage;
    while (pageIndex <= endPage && !this.hasPageBeenSearched(pageIndex)) {
      pagesNotSearched.push(pageIndex);
      pageIndex += 1;
    }
    if (pagesNotSearched.length > 0) {
      newStartPage = pagesNotSearched[0];
      newSearchWindowSize = pagesNotSearched[pagesNotSearched.length - 1] - pagesNotSearched[0] + 1;
    }
    return {
      startPage: newStartPage,
      searchWindowSize: newSearchWindowSize
    };
  }

  setPagesSearchedState(startPage, searchWindowSize) {
    this.setPagesSearchState(startPage, searchWindowSize, pageSearchStates.SEARCHED);
  }

  setPagesBeingSearchedState(startPage, searchWindowSize) {
    this.setPagesSearchState(startPage, searchWindowSize, pageSearchStates.BEING_SEARCHED);
  }

  setPagesSearchState(startPage, searchWindowSize, pageSearchState) {
    for (let i = startPage; i < startPage + searchWindowSize; i++) {
      this.pagesSearchState[i] = pageSearchState;
    }
  }

  getNumberOfSearchedPages() {
    return this.pagesSearchState.filter(pageSearchState => pageSearchState === pageSearchStates.SEARCHED).length;
  }

  getNextSearchWindow() {
    let newStartPage = -1;
    let newSearchWindowSize = 0;
    if (this.pagesSearchState[this.nextStartPage] === pageSearchStates.NOT_SEARCHED) {
      newStartPage = this.nextStartPage;
      let newEndPage = newStartPage;
      while (
        newEndPage < this.pagesSearchState.length &&
        this.pagesSearchState[newEndPage] === pageSearchStates.NOT_SEARCHED &&
        newEndPage < newStartPage + SEARCH_WINDOW_SIZE
      ) {
        newEndPage += 1;
      }
      newSearchWindowSize = newEndPage - newStartPage;
      if (newEndPage === this.pagesSearchState.length) {
        this.nextStartPage = 0;
      } else {
        this.nextStartPage = newEndPage;
      }
    }
    return {
      startPage: newStartPage,
      searchWindowSize: newSearchWindowSize
    };
  }
}

export { SearchWindowManager };
